/**
 *
 * Datadog Browser Logs SDK for collecting and forwarding browser logs to Datadog.
 * Provides comprehensive logging capabilities with automatic error tracking and custom log collection.
 *
 * @packageDocumentation
 * @see [Browser Log Collection](https://docs.datadoghq.com/logs/log_collection/javascript/)
 */
import { defineGlobal, getGlobalObject } from '@openobserve/browser-core';
import { makeLogsPublicApi } from '../boot/logsPublicApi';
import { startLogs } from '../boot/startLogs';
export { Logger, HandlerType } from '../domain/logger';
export { StatusType } from '../domain/logger/isAuthorized';
export const openobserveLogs = makeLogsPublicApi(startLogs);
defineGlobal(getGlobalObject(), 'OO_LOGS', openobserveLogs);
//# sourceMappingURL=main.js.map